export default __webpack_public_path__ + "static/media/ST4_Grand_mellow.899bac48.png";